import { paths } from "../services/ServiceConstants.tsx";

export const LOGIN_STATUS = {
  INITIATED: "initiated",
  AUTHENTICATED: "authenticated",
  NO_AUTHENTICATED: "no-authenticated",
};

export const Constants = {
  APP_NAME: "Kshema POSP Finder App",
  AUTHENTICATION_DATUM: "authenticationDatum",
};

export const CLICK_ACTIONS = {
  POSP_TABLE_ACTION: "posp_call_direction",
};

export const MARKERS_OPTIONS = [
  "POSPs",
  "Universities",
  "Policies",
  "Crops",
  "Area",
  "Customers",
  "Premium",
  "Insured Area",
  "Sum Insured",
  "Waterbodies",
];
export const GRID_OPTIONS = [
  "Premium Grid View",
  "Sum Insured Grid View",
  "Policies Grid View",
  "Waterbodies",
];
export const ACTIVE_VIEW_STATE = "state";
export const ACTIVE_VIEW_COUNTRY = "country";
export const ACTIVE_VIEW_CONSOLIDATED = "consolidated";
export const FILTER_TYPE = {
  GRID_FILTER: "grid",
  MARKER_FILTER: "marker",
};
export const NOT_FOUND = "Not found";
export const NO_TOKEN = "not_token";
export const defaultPosition = [21.1458, 79.0882]; // initial coordinates pointing to India
export const ENV_TYPE =
  paths.BASE_URL?.includes("poc") || paths.BASE_URL?.includes("dev")
    ? "poc"
    : "prod";
export const DATE_FORMAT = {
  DD_MM_YYYY: "DD-MM-YYYY",
  YYYY_MM_DD: "YYYY-MM-DD",
  d_m_Y: "d-m-Y",
};
export const COLOR = {
  country: {
    min: "#C5DBFF",
    max: "#597AB1",
  },
  state: {
    min: "#C5DBFF",
    max: "#597AB1",
  },
  // state: {
  //   min: "#E2F0D9",
  //   max: "#548235",
  // },
  white: "#FFFFFF",
  black: "#000000",
  transparent: "transparent",
};
export const MARKER_DETAILS = {
  posps: "posp_details",
  policies: "policy_details",
};
export const MAP_VIEW = {
  STATE_WISE: "State",
  GRID_WISE: "Grid",
};

export const COMBINED_LEVELS_FILTER = {
  POSPm_POSP: "POSPm-POSP",
  POSPm_ARABLE: "POSPm-Arable",
  POSPm_TARGET: "POSPm-Target",
  POSPm_LOCATION: "POSPm-Real Time Location",
  Policy_Customer_Count: "Policy-Customer Count",
  Policy_Policy_Count: "Policy-Policy Count",
  Policy_Insured_Area: "Policy-Insured Area",
  Policy_Sum_Insured: "Policy-Sum Insured",
  Policy_Premium: "Policy-Premium",
  area: "area",
  Claims_Customer_Count: "Claims-Customer Count",
  Claims_Claim_Processed: "Claims-Claim Processed",
  Claims_Claim_Pending: "Claims-Claim Pending",
  Claims_Amount_Disbursed: "Claims-Amount Disbursed",
  Claims_Amount_Can_Be_Disbursed: "Claims-Amount Can Be Disbursed",
  Claims_Loss_Ratio: "Claims-Loss Ratio(Claim/Premium)",
  Claims_Total_Claim_Count: "Claims-Total Claim Count",
  Claims_Loss_Reserve: "Claims-Claim Pending (Before Approval) - Loss Reserve",
  Claims_Payment_Not_Initiated: "Claims-Approved But Payment Not Initiated",
  Claims_Payment_Initiated: "Claims-Payment Initiated But Not Completed",
  Claims_Paid: "Claims-Claim Paid",
  Claims_Rejected: "Claims-Rejected",
  Claims_Repudiated: "Claims-Repudiated",
  Claims_Cwp: "Claims-CWP",
  Weather_Rainfall: "Weather-Rainfall",
};

export const AGGREGATED_TITLE = {
  total_posps: "Total POSPs",
  total_target_value: "Total Target Value",
  total_arable_area: "Total Arable Area",
  total_policies: "Total Policies",
  total_premium: "Total Premium",
  total_insured_area: "Total Insured Area",
  total_suminsured: "Total Sum Insured",
  total_customers: "Total Customers",
  total_claims: "Total Claims",
  total_payout: "Total Payout",
  average_loss_ratio: "Average Loss Ratio",
};
export const ALL_CROPS = "All Crops";
export const ALL_PRODUCT = "All Product";
export const TABLE_ACTION = {
  GRID_SELECTION: "grid_selection",
};

export const TABLE_SORT_ASC = "ASC";
export const TABLE_SORT_DESC = "DESC";
export const NOT_AVAILABLE = "N/A";
export const CHART_TYPE = {
  BAR: "bar",
  BUBBLE: "bubble",
  DOUGHNUT: "doughnut",
  PIE: "pie",
};
export const SCREEN_TYPE = {
  NORMAL: "normal",
  NOC: "noc",
};
export const ALL_STATE = "All State";

export const NOC_LEVEL = [
  {
    levelOne: "Policy",
    levelTwo: "Policy Count",
  },
  {
    levelOne: "Policy",
    levelTwo: "Premium",
  },
  {
    levelOne: "Policy",
    levelTwo: "Insured Area",
  },
  {
    levelOne: "Policy",
    levelTwo: "Sum Insured",
  },
  {
    levelOne: "Policy",
    levelTwo: "Customer Count",
  },
  {
    levelOne: "Claims",
    levelTwo: "Total Claim Count",
  },
  {
    levelOne: "Claims",
    levelTwo: "Loss Ratio(Claim/Premium)",
  },
  {
    levelOne: "Claims",
    levelTwo: "Amount Disbursed",
  },
  {
    levelOne: "Claims",
    levelTwo: "Pending Claims",
  },

  { levelOne: "Claims", levelTwo: "Loss Reserve" },
  { levelOne: "Claims", levelTwo: "Payment Not Initiated" },

  {
    levelOne: "POSPm",
    levelTwo: "POSP",
  },
];

//  {
//     levelOne: "Policy",
//     levelTwo: "Insured Area",
//   },
//   {
//     levelOne: "Policy",
//     levelTwo: "Sum Insured",
//   },
export const CLAIMS_LEVEL = [
  {
    levelOne: "Claims",
    levelTwo: "Total Claim Count",
  },

  { levelOne: "Claims", levelTwo: "Loss Reserve" },
  { levelOne: "Claims", levelTwo: "Payment Not Initiated" },
];
export const PRODUCTS = {
  "1": "Kshema Sukriti",
  "2": "Kshema Prakriti",
  "5": "Kshema Samriddhi",
};

// Ensure this exists in Constants.tsx
export const CLAIMS_PROCESSED_CATEGORIES = [
  "Claims Rejected",
  "Repudiated",
  "Closed at Nil",
  "Closed after payment",
];

//Optional, if API expects canonical keys instead of labels:
export const CLAIMS_CATEGORY_KEY_MAP: Record<string, string> = {
  "Claims Rejected": "rejected",
  Repudiated: "repudiated",
  "Closed at Nil": "closed_nil",
  "Closed after payment": "closed_paid",
};

export const NEW_CROP_API_LEVEL = [
  "Premium",
  "Policy Count",
  "Sum Insured",
  "Insured Area",
  "Total Claim Count",
  "Loss Ratio(Claim/Premium)",
];
export const STATE_CODE_NAME = {
  "1": { code: "JK", name: "Jammu And Kashmir" },
  "2": { code: "HP", name: "Himachal Pradesh" },
  "3": { code: "PB", name: "Punjab" },
  "4": { code: "CH", name: "Chandigarh" },
  "5": { code: "UK", name: "Uttarakhand" },
  "6": { code: "HR", name: "Haryana" },
  "7": { code: "DL", name: "Delhi" },
  "8": { code: "RJ", name: "Rajasthan" },
  "9": { code: "UP", name: "Uttar Pradesh" },
  "10": { code: "BR", name: "Bihar" },
  "11": { code: "SK", name: "Sikkim" },
  "12": { code: "AR", name: "Arunachal Pradesh" },
  "13": { code: "NL", name: "Nagaland" },
  "14": { code: "MN", name: "Manipur" },
  "15": { code: "MZ", name: "Mizoram" },
  "16": { code: "TR", name: "Tripura" },
  "17": { code: "ML", name: "Meghalaya" },
  "18": { code: "AS", name: "Assam" },
  "19": { code: "WB", name: "West Bengal" },
  "20": { code: "JH", name: "Jharkhand" },
  "21": { code: "OD", name: "Odisha" },
  "22": { code: "CG", name: "Chhattisgarh" },
  "23": { code: "MP", name: "Madhya Pradesh" },
  "24": { code: "GJ", name: "Gujarat" },
  "26": { code: "DN", name: "Dadra and Nagar Haveli and Daman and Diu" },
  "27": { code: "MH", name: "Maharashtra" },
  "29": { code: "KA", name: "Karnataka" },
  "30": { code: "GA", name: "Goa" },
  "31": { code: "LD", name: "Lakshadweep" },
  "32": { code: "KL", name: "Kerala" },
  "33": { code: "TN", name: "Tamil Nadu" },
  "34": { code: "PY", name: "Puducherry" },
  "35": { code: "AN", name: "Andaman and Nicobar Islands" },
  "36": { code: "TG", name: "Telangana" },
  "37": { code: "AP", name: "Andhra Pradesh" },
  "38": { code: "LA", name: "Ladakh" },
};

export const BUBBLE_CHART_COLOR = [
  "#F67972",
  "#3498D1",
  "#52DBB6",
  "#FFCD5D",
  "#A3A5FE",
  "#E38CBD",
  "#96D9FE",
  "#FFAC6A",
  "#70C8B1",
  "#883E88",
];
export const COUNTRY = "Country";
export const STATE_ARRAY = [
  {
    latitude: "33.64697687061",
    longitude: "74.8593264680723",
    sid: 1,
    state: "Jammu And Kashmir",
  },
  {
    latitude: "31.9243412266936",
    longitude: "77.2425760572406",
    sid: 2,
    state: "Himachal Pradesh",
  },
  {
    latitude: "30.8424472999387",
    longitude: "75.4154816567894",
    sid: 3,
    state: "Punjab",
  },
  {
    latitude: "30.7293523660787",
    longitude: "76.780521217077",
    sid: 4,
    state: "Chandigarh",
  },
  {
    latitude: "30.1564754131567",
    longitude: "79.206712027814",
    sid: 5,
    state: "Uttarakhand",
  },
  {
    latitude: "29.1979989230919",
    longitude: "76.3402071437277",
    sid: 6,
    state: "Haryana",
  },
  {
    latitude: "28.6433914269955",
    longitude: "77.1154818508668",
    sid: 7,
    state: "Delhi",
  },
  {
    latitude: "26.5845451251484",
    longitude: "73.8498231069741",
    sid: 8,
    state: "Rajasthan",
  },
  {
    latitude: "26.9232704362598",
    longitude: "80.5660445234626",
    sid: 9,
    state: "Uttar Pradesh",
  },
  {
    latitude: "25.6791830374543",
    longitude: "85.6106913566687",
    sid: 10,
    state: "Bihar",
  },
  {
    latitude: "27.5702678360448",
    longitude: "88.4747964120326",
    sid: 11,
    state: "Sikkim",
  },
  {
    latitude: "28.0356893740224",
    longitude: "94.6755883266802",
    sid: 12,
    state: "Arunachal Pradesh",
  },
  {
    latitude: "26.0618681728739",
    longitude: "94.4663625633656",
    sid: 13,
    state: "Nagaland",
  },
  {
    latitude: "24.734821644592",
    longitude: "93.8781892615402",
    sid: 14,
    state: "Manipur",
  },
  {
    latitude: "23.3075691516464",
    longitude: "92.833581899577",
    sid: 15,
    state: "Mizoram",
  },
  {
    latitude: "23.7454304686663",
    longitude: "91.7407424915924",
    sid: 16,
    state: "Tripura",
  },
  {
    latitude: "25.535477394709",
    longitude: "91.2773777807423",
    sid: 17,
    state: "Meghalaya",
  },
  {
    latitude: "26.3552800648931",
    longitude: "92.82615150789",
    sid: 18,
    state: "Assam",
  },
  {
    latitude: "23.8057025806551",
    longitude: "87.9865278932777",
    sid: 19,
    state: "West Bengal",
  },
  {
    latitude: "23.6545962575861",
    longitude: "85.5615617567453",
    sid: 20,
    state: "Jharkhand",
  },
  {
    latitude: "20.5130264219964",
    longitude: "84.431284226851",
    sid: 21,
    state: "Odisha",
  },
  {
    latitude: "21.2663295960496",
    longitude: "82.0411157658584",
    sid: 22,
    state: "Chhattisgarh",
  },
  {
    latitude: "23.5381638755022",
    longitude: "78.2891283481177",
    sid: 23,
    state: "Madhya Pradesh",
  },
  {
    latitude: "22.6830137483485",
    longitude: "71.5799463330437",
    sid: 24,
    state: "Gujarat",
  },
  {
    latitude: "20.2525308595235",
    longitude: "72.9066266260355",
    sid: 26,
    state: "The Dadra And Nagar Haveli And Daman And Diu",
  },
  {
    latitude: "19.4514545866005",
    longitude: "76.106435548542",
    sid: 27,
    state: "Maharashtra",
  },
  {
    latitude: "14.710191538394",
    longitude: "76.1670647165628",
    sid: 29,
    state: "Karnataka",
  },
  {
    latitude: "15.3650909587554",
    longitude: "74.0491544977398",
    sid: 30,
    state: "Goa",
  },
  {
    latitude: "10.4514586411658",
    longitude: "72.9513681668316",
    sid: 31,
    state: "Lakshadweep",
  },
  {
    latitude: "10.4514903420919",
    longitude: "76.4073163901595",
    sid: 32,
    state: "Kerala",
  },
  {
    latitude: "11.0153699309874",
    longitude: "78.408733076447",
    sid: 33,
    state: "Tamil Nadu",
  },
  {
    latitude: "11.9620332683004",
    longitude: "79.8633440455756",
    sid: 34,
    state: "Puducherry",
  },
  {
    latitude: "11.2082791096238",
    longitude: "92.9598462005205",
    sid: 35,
    state: "Andaman and Nicobar Islands",
  },
  {
    latitude: "17.8008125243725",
    longitude: "79.0079046662557",
    sid: 36,
    state: "Telangana",
  },
  {
    latitude: "15.7562579122376",
    longitude: "79.9659490123518",
    sid: 37,
    state: "Andhra Pradesh",
  },
  {
    latitude: "34.9479611517157",
    longitude: "76.7739413372935",
    sid: 38,
    state: "Ladakh",
  },
];

export const DOUGHNUT_TYPE = {
  single: "SINGLE",
  double: "DOUBLE",
};
export const REAL_TIME_LOCATION = "Real Time Location";
export const MARKER_TYPE = {
  POSPS: "posps",
  STATE: "state",
};

export const RAIN_LEGEND_VALUE = [
  { range: "0-2.4", color: "#add8e6" },
  { range: "2.4-7.5", color: "#87ceeb" },
  { range: "7.5-35.5", color: "#00ff00" },
  { range: "35.5-64.4", color: "#ffff00" },
  { range: "64.4-124.4", color: "#ffd700" },
  { range: "124.4-244.5", color: "#ffa500" },
  { range: "244.5-50000", color: "#ff0000" },
];
